import React from 'react';
import { useBanners } from '../../hooks/useBanners';
import { BANNER_CATEGORY } from '../../constants/bannerCategory';
import AntdCarousel from './AntdCarousel';

const MainBanner = () => {
  const { banners, loading, handleBannerClick, handleBannerChange } =
    useBanners(BANNER_CATEGORY.MAIN);

  return (
    <AntdCarousel
      location="MAIN"
      bannerItems={banners}
      loading={loading}
      handleBannerClick={handleBannerClick}
      handleBannerChange={handleBannerChange}
    />
  );
};

export default MainBanner;
